<template>
  <div class="signInDetail">
    <div class="mobileHeader">
      <p>采购单号：{{ list.relationNumber }}</p>
      <p>SKU：{{ list.skuCode }}</p>
      <p>
        <span>到仓日期：{{ list.signForTime }}</span
        ><span
          >上架件数：{{ list.totalBoxCount || 0 }}/<span class="red">{{
            list.tailBoxPcsQty > 0
              ? 1 + (Number(list.completeBoxCount) || 0)
              : Number(list.completeBoxCount) || 0
          }}</span></span
        >
      </p>
      <p>
        <span
          >上架数量：{{ list.totalQty || 0 }}/<span class="red">{{
            Number(list.tailBoxPcsQty || 0) +
            Number((list.singleBoxQty || 0) * (list.completeBoxCount || 0))
          }}</span></span
        ><span>签收人：{{ list.signForUser }}</span>
      </p>
    </div>

    <van-tabs
      v-model="active"
      line-width="50%"
      line-height="2px"
      color="#29c727"
    >
      <van-tab title="上架">
        <div class="sign-item">
          <div class="signInDetail-content">
            <van-notice-bar color="#1989fa" background="#ecf9ff"
              >请确认以下签收信息是否正确,有误请修改:</van-notice-bar
            >
            <span class="mr10">SKU: {{ list.skuCode }}</span
            ><span>数量：{{ list.totalQty || 0 }}</span>
            <p>名称：{{ list.productNameCN }}</p>
          </div>
          <div class="signInDetail-btnBox">
            <ul>
              <li>
                <span>长CM</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.boxLength"
                  @change="inputNumChange('boxLength')"
                  min="0"
                  max="10000"
                />
                <span>宽CM</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.boxWidth"
                  @change="inputNumChange('boxWidth')"
                  min="0"
                  max="10000"
                />
                <span>高CM</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.boxHeight"
                  @change="inputNumChange('boxHeight')"
                  min="0"
                  max="10000"
                />
              </li>
              <li>
                <span>单箱重量(kg)</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.boxWeight"
                  @change="inputNumChange('boxWeight', 3)"
                  min="0"
                  max="10000"
                />
              </li>
              <li>
                <span>单箱数量</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.singleBoxQty"
                  @change="inputParseIntNumChange('singleBoxQty')"
                  min="0"
                  max="10000"
                />
                <!-- <span style="color: red;">件数</span> -->
                <span>件数</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.completeBoxCount"
                  @change="inputParseIntNumChange('completeBoxCount')"
                  min="0"
                  max="10000"
                />
                <span
                  >{{ list.singleBoxQty || 0 }} *
                  {{ list.completeBoxCount || 0 }} =
                  {{
                    (list.singleBoxQty || 0) * (list.completeBoxCount || 0)
                  }}</span
                >
              </li>
              <li>
                <span>尾箱数量</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.tailBoxPcsQty"
                  @change="inputParseIntNumChange('tailBoxPcsQty')"
                  min="0"
                  max="10000"
                />
                <span>尾箱重量(kg)</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.tailBoxWeight"
                  @input="tailBoxWeightInput"
                  @change="inputNumChange('tailBoxWeight', 3)"
                  min="0"
                  max="10000"
                />
              </li>
              <li style="white-space: normal; display: table">
                <span
                  >确认总数量：<span style="color: red">{{
                    Number(list.tailBoxPcsQty || 0) +
                    Number(
                      (list.singleBoxQty || 0) * (list.completeBoxCount || 0)
                    )
                  }}</span></span
                >
                <p style="color: red; font-size: 13px; margin-top: -20px">
                  (修改后的总数量需和原收货单保持一致)
                </p>
              </li>
            </ul>
          </div>
          <div>
            <button class="submit-btn" @click="$router.go(-1)">返回</button>
            <button class="submit-btn confirm-btn" @click="confirm">
              确认操作上架
            </button>
          </div>
        </div>
      </van-tab>
      <van-tab title="拍照">
        <div class="sign-photo-cpntent">
          <div class="sign-photo-box">
            <ul>
              <li
                class="sign-photo-item"
                v-for="(item, index) in saveSrcArr"
                :key="index"
              >
                <span class="delete-icon" @click="deleteImg(index)">x</span>
                <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
                <img
                  :src="item.base64Url"
                  class="sign-photo-item-img"
                  alt=""
                  @click="previewImage(item.base64Url)"
                />
              </li>

              <li class="sign-photo-btn">
                <div class="photo">
                  <input
                    class="img hidden"
                    @change="changeImg()"
                    type="file"
                    name="cover"
                    ref="inputer"
                    accept="image/*"
                    multiple
                  />
                  <p @click="chooseImage">
                    <i class="el-icon-camera"></i>
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <div class="sign-photo-save">
            <button class="submit-btn">保存</button>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Tab,
  Tabs,
  NoticeBar,
  Dialog,
  ImagePreview,
  Toast,
} from "vant";
import { isMobileTerminal } from "util/validate";
import util from "util/date";
import { getPutOnDetail, submitPutOnBox } from "@/api/mobile/putaway_api";

export default {
  data() {
    return {
      submitData: {},
      active: 0,
      saveSrcArr: [],
      list: {},
      isPutawayPath: false,
      itemArr: [
        "长",
        "宽",
        "高",
        "单箱重量",
        "单箱数量",
        "件数",
        "尾箱数量",
        "尾箱重量",
      ],
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Tab.name]: Tab,
    [Toast.name]: Toast,
    [Tabs.name]: Tabs,
    [NoticeBar.name]: NoticeBar,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.name]: ImagePreview,
  },

  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getPutOnDetail();
      this.scrollIntoView();
    },

    getPutOnDetail() {
      const { putOnNo, skuCode } = this.$route.query;
      const data = {
        putOnNo,
        skuCode,
      };
      if (this.isPutawayPath) {
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
      }

      getPutOnDetail(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          const { response } = res;

          for (let i = 0; i < response.length; i++) {
            const r = response[i];

            if (r.putStockBoxInfoID && this.isPutawayPath) {
              this.$router.push({
                path: "/mobile/putawayConfirm",
                query: { boxInfoID: r.putStockBoxInfoID },
              });
            }
            if (r.putStockBoxInfoID && !this.isPutawayPath) {
              this.$router.replace("/mobile/putaway");
              this.$router.go(-1);
            }
          }
          response.forEach(function (row) {
            row.signForTime = util.formatDate.format(
              new Date(row.signForTime),
              "yyyy-MM-dd"
            );
          });

          this.list = response[0];
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    inputNumChange(field, fix = 1) {
      function toF(n, fix) {
        return Number(n).toFixed(fix);
      }

      let num = toF(this.list[field], fix);

      if (num > 10000) {
        Toast("数值最大10000");
        num = toF(10000, fix);
      } else if (num < 0) {
        Toast("请输入正数");
        num = toF(0, fix);
      }
      this.$set(this.list, field, num);
    },

    inputParseIntNumChange(field) {
      let num = Number(this.list[field]);
      if (num > 10000) {
        Toast("数值最大10000");
        num = 10000;
      } else if (num < 0) {
        Toast("请输入正整数");
        num = Math.abs(num);
      }
      if (field === "tailBoxPcsQty" && num === 0) {
        this.$set(this.list, "tailBoxWeight", "0");
      }

      const { sourceTypeID } = this.list;
      if (sourceTypeID != 3) {
        if (
          field === "tailBoxPcsQty" &&
          num >= Number(this.list["singleBoxQty"])
        ) {
          Toast("尾箱数量需小于单箱数量");
          num = 0;
        }
      }

      this.$set(this.list, field, parseInt(num));
    },

    tailBoxWeightInput() {
      if (!this.list.tailBoxPcsQty) {
        this.$set(this.list, "tailBoxWeight", "0");
        Toast("请先输入尾箱数量");
      }
    },

    checkParam() {
      const {
        boxLength,
        boxWidth,
        boxHeight,
        boxWeight,
        singleBoxQty,
        completeBoxCount,
        sourceTypeID,
      } = this.list;
      const obj =
        sourceTypeID != 3
          ? {
              boxLength,
              boxWidth,
              boxHeight,
              boxWeight,
              singleBoxQty,
              completeBoxCount,
            }
          : {};

      const valueArr = Object.values(obj);
      for (let i = 0; i < valueArr.length; i++) {
        const v = valueArr[i];
        if (v === 0 || v === "0.000" || v === "0.0" || !v) {
          Toast(`请输入${this.itemArr[i]}`);
          return false;
        }
      }
    },

    async submit() {
      const { putOnNo } = this.$route.query;

      const {
        totalQty,
        putOnBoxInfoID,
        boxLength,
        boxWidth,
        boxHeight,
        boxWeight,
        singleBoxQty,
        completeBoxCount,
        tailBoxPcsQty,
        tailBoxWeight,
        sourceTypeID,
      } = this.list;
      const data = {
        putOnNo: putOnNo,
        totalBoxCount:
          tailBoxPcsQty > 0
            ? 1 + (Number(completeBoxCount) || 0)
            : Number(completeBoxCount) || 0,
        totalQty,
        putOnBoxInfoID,
        boxLength,
        boxWidth,
        boxHeight,
        boxWeight,
        singleBoxQty,
        completeBoxCount,
        tailBoxPcsQty,
        tailBoxWeight,
        sourceTypeID,
      };

      Toast.loading({
        message: "上架中...",
        forbidClick: true,
      });
      const that = this;

      await submitPutOnBox(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          Toast.fail("上架成功");

          setTimeout(function () {
            that.$router.push(
              `/mobile/putawayConfirm?boxInfoID=${res.response}`
            );
          }, 1000);
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    confirm() {
      if (this.checkParam() == false) {
        return;
      }

      if (
        this.list.totalQty !=
        Number(this.list.tailBoxPcsQty) +
          Number(
            (this.list.singleBoxQty || 0) * (this.list.completeBoxCount || 0)
          )
      ) {
        Toast.fail(
          "与原收货单数量不一致，请重新修改。或废弃原收货单再行签收。"
        );
        return;
      }

      Dialog.confirm({
        title: "确认",
        confirmButtonText: "确认无误",
        cancelButtonText: "再确认一次",
        message:
          '请确认箱规信息是否正确?<br/><span style="color:red;">谨慎操作,确认后数据不可逆</span>',
      })
        .then(() => {
          this.submit();
        })
        .catch(() => {});
    },

    scrollIntoView() {
      window.addEventListener("resize", () => {
        const activeElement = document.activeElement;
        if (
          activeElement.tagName === "INPUT" ||
          activeElement.tagName === "TEXTAREA"
        ) {
          setTimeout(() => {
            activeElement.scrollIntoView(false);
            activeElement.scrollIntoViewIfNeeded();
          }, 100);
        }
      });
    },

    deleteImg() {},

    changeImg() {
      const img = document.getElementsByClassName("img")[0];
      let imgList = [...img.files];
      console.log("imgList", imgList);

      this.handleFiles(imgList);
    },

    chooseImage() {
      if (!isMobileTerminal()) {
        // 是移动端
        // 调用微信api
      } else {
        document.getElementsByClassName("img")[0].click();
      }
    },

    // 预览图片
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },

    handleFiles(files) {
      let srcArr = []; // 保存转换的base64 imgFileUrl

      for (var i = 0; i < files.length; i++) {
        var file = files[i];

        const { type, name } = file;

        var imageType = /^image\//;
        if (!imageType.test(type)) {
          continue;
        }

        let obj = { name };

        var reader = new FileReader();
        reader.onload = function (e) {
          obj.base64Url = e.target.result;
          srcArr.push(obj);
        };
        reader.readAsDataURL(file);
      }

      this.saveSrcArr = srcArr;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path === "/mobile/putaway") {
        vm.isPutawayPath = true;
      } else {
        vm.isPutawayPath = false;
      }
    });
  },
};
</script>

<style lang="less" scoped>
.signInDetail .mobileHeader {
  padding: 0 10px 15px;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
  p {
    margin: 5px 0;
    display: flex;
    word-break: break-all;
    span {
      flex: 1;
    }
  }
}
::v-deep .van-tabs__line {
  background-color: #29c727;
}
.sign-item {
  background-color: #fbf9fe;
  padding: 10px;
  .signInDetail-content {
    font-size: 15px;
  }
  .signInDetail-btnBox {
    li {
      line-height: 40px;
      white-space: nowrap;
      display: flex;
      align-items: baseline;
    }
    .volume {
      min-width: 10%;
      max-width: 22%;
      height: 22px;
      line-height: 22px;
      font-size: 14px;
      border: 1px solid #ccc;
      outline: none;
      margin: 0 5px;
      padding: 0 5px;
      box-sizing: border-box;
    }
  }
}
.submit-btn {
  width: 49%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 15px;
  border: 0;
}
.confirm-btn {
  background-color: #ff0000;
  float: right;
}
.sign-photo-box {
  margin: 5px 10px 10px;
  border: 1px solid #797979;
  box-sizing: border-box;
  padding: 10px;
  ul {
    .sign-photo-item {
      width: 100px;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      display: inline-block;
      margin: 0 4.5% 4.5% 0;
      overflow: hidden;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }
      .sign-photo-item-img {
        width: 100%;
      }
    }
    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      .photo {
        width: 100px;
        height: 100px;
        background-color: #faf9fc;
        position: relative;
        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;
          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
.sign-photo-save {
  padding: 0 10px;
}
.hidden {
  display: none;
}
.mr10 {
  margin-right: 10%;
}
.red {
  color: red;
}
::v-deep .van-icon-photo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::v-deep .van-notice-bar {
  height: 30px;
  line-height: 30px;
  font-size: 13px;
}

@media screen and (max-width: 360px) {
  .signInDetail-btnBox {
    li {
      font-size: 14px;
    }
  }
}
</style>